import React, { createContext } from 'react';
import { updateOrganization, userLogin, userLogout } from '../api';
import useAsync from '../hooks/useAsync';
import { getOrganization } from '../api/admin';
import { useNavigate } from 'react-router-dom';

const AppContext = createContext();

export const AppProvider = ({ children }) => {

	const navigate = useNavigate();

	const {
		value: user,
		execute: onUserLogin,
		status: isLoggingIn,
		error,
	} = useAsync(userLogin, {
		immediate: false,
	});

	const { execute: onUpdateOrganization, status: isUpdatingOrg } = useAsync(
		updateOrganization,
		{ immediate: false }
	);

	const { execute: refreshOrganization } = useAsync(getOrganization, {
		immediate: false,
	});

	const localUser = JSON.parse(localStorage.getItem('user'));

	const getUser = (u) =>
		u
			? {
					email: u?.email,
					firstName: u?.firstName,
					lastName: u?.lastName,
					id: u?.id,
			  }
			: null;

	return (
		<AppContext.Provider
			value={{
				organization: user ? user?.organization : localUser?.organization,
				user: getUser(localUser || user),
				role: user ? user.role : localUser?.role,
				error,
				isLoggingIn: isLoggingIn === 'pending',
				onUpdateUser: (updated) => {
					const u = localStorage.getItem('user');
					const updatedUser = JSON.stringify({
						...JSON.parse(u),
						...updated,
					});

					localStorage.setItem('user', updatedUser);
					return JSON.parse(updatedUser);
				},
				login: (payload, cb) => {
					onUserLogin(payload, (response) => {
						localStorage.setItem('user', JSON.stringify(response));

						if (typeof cb === 'function') {
							cb();
						} else {
							navigate('/');
						}
					});
				},
				logout: () => {
					console.log('logout')
					userLogout();
					navigate('/');
				},
				switchOrganization: (organizationId) => {
					onUpdateOrganization({ id: organizationId }, (payload) => {
						localStorage.setItem(
							'user',
							JSON.stringify({
								...localUser,
								organization: payload?.organization,
							})
						);
						navigate('/');
					});
				},
				refreshOrganization: () => {
					refreshOrganization(localUser?.organization?.id, (payload) => {
						localStorage.setItem(
							'user',
							JSON.stringify({
								...localUser,
								organization: payload,
							})
						);
						navigate('/');
					});
				},
			}}
		>
			{children}
		</AppContext.Provider>
	);
};

export const AppConsumer = AppContext.Consumer;

export default AppContext;
